import { motion } from "framer-motion";
import { IMG } from "../lib/assets";

export const DropTeaser = ({ className = "" }) => (
  <div data-testid="drop-teaser" className={`relative bg-white overflow-hidden aspect-[4/5] border-2 border-[#0B0B0B] shadow-[10px_10px_0_#0B0B0B] ${className}`}>
    <img src={IMG.jersey} alt="Blurred teaser of the next Project X drop" className="absolute inset-0 w-full h-full object-contain scale-110 blur-[14px] saturate-150" />
    <div className="absolute inset-0 bg-white/20" />
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 px-6">
      <div className="relative w-36 h-36 sm:w-44 sm:h-44" data-testid="drop-teaser-loader">
        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full -rotate-90" aria-hidden>
          <circle cx="50" cy="50" r="45" fill="white" stroke="#0B0B0B" strokeOpacity="0.12" strokeWidth="5" />
        </svg>
        <motion.svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 1.6, ease: "linear" }} aria-hidden>
          <circle cx="50" cy="50" r="45" fill="none" stroke="#E10600" strokeWidth="5" strokeLinecap="round" strokeDasharray="70 213" />
        </motion.svg>
        <motion.div className="absolute inset-0 flex items-center justify-center" animate={{ scale: [1, 1.08, 1] }} transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}>
          <img src={IMG.xRed} alt="" aria-hidden className="w-[52%] h-[52%] object-contain" data-testid="drop-teaser-x" />
        </motion.div>
      </div>
      <div className="w-full max-w-[220px] bg-white border-2 border-[#0B0B0B] px-3 py-2">
        <p className="font-mono-x uppercase text-[11px] tracking-[0.25em] font-bold text-[#0B0B0B] text-center">Loading X Drop Soon</p>
        <div className="mt-2 h-1.5 bg-zinc-200 overflow-hidden">
          <motion.div className="h-full w-1/3 bg-[#E10600]" animate={{ x: ["-100%", "300%"] }} transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }} />
        </div>
      </div>
    </div>
    <span className="absolute top-3 left-3 bg-[#0B0B0B] text-white font-mono-x text-[11px] uppercase tracking-[0.2em] px-2 py-1">Classified</span>
  </div>
);
